exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".imosSdk-video{height:100%!important;width:100%!important;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
